import React from 'react'
import classNames from 'classnames'
import { HiChevronDoubleLeft, HiChevronLeft } from 'react-icons/hi2'
import { FaAngleDoubleLeft } from 'react-icons/fa'

const Prev = (props) => {
    const { currentPage, pagerClass, onFir } = props

    const disabled = currentPage <= 1

    const onPrevClick = (e) => {
        if (disabled) {
            return
        }
        onFir(1)
    }

    const pagerPrevClass = classNames(
        pagerClass.default,
        'pagination-pager-prev',
        disabled ? pagerClass.disabled : pagerClass.inactive
    )

    return (
        <span className={pagerPrevClass} onClick={onPrevClick}>
            <HiChevronDoubleLeft size={20}/>
        </span>
    )
}

export default Prev
